import { createFileRoute } from '@tanstack/react-router'

import { ClientOverview } from '@/components/clients/client-overview'
import { useShellClient } from '@/components/clients/shell-client'
import { matching, readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId/')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /** Lot 19 (`web_path`) : le jalon désigné, épinglé en tête de l'aperçu. */
        milestone: matching(/^[0-9a-f]{24}$/),
      },
      search,
    ),
  component: ClientOverviewPage,
})

function ClientOverviewPage() {
  const client = useShellClient()
  const { milestone } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <ClientOverview
      client={client}
      focusMilestoneId={milestone}
      onDismissFocus={() => {
        void navigate({ search: { milestone: undefined }, replace: true })
      }}
    />
  )
}
